export const EVENTS = {
  SHARER: {
    RESTAU: {
      SHOW: 'sharer.restau.show'
    },
    DISH: {
      SHOW: 'sharer.dish.show'
    }
  }
};

export const SHARINGS_OPTIONS = [
  {
    type: 'whatsapp',
    logo: '/images/icons/whatsapp-green.svg',
    name: 'Whatsapp',
    class: 'bg-primary/10'
  },
  {
    type: 'facebook',
    logo: '/images/icons/facebook-blue.svg',
    name: 'Facebook',
    class: 'bg-primary/10'
  },
  {
    type: 'telegram',
    logo: '/images/icons/telegram-blue.svg',
    name: 'Télégram',
    class: 'bg-primary/10'
  },
  {
    type: 'instagram',
    logo: '/images/icons/instagram_1.svg',
    name: 'Instagram',
    class: 'bg-primary/10'
  },
  {
    type: 'snapchat',
    logo: '/images/icons/snapchat.svg',
    name: 'Snapchat',
    class: 'bg-[#ff0]'
  },
  {
    type: 'x',
    logo: '/images/icons/x-logo.svg',
    name: 'X/Twitter',
    class: 'bg-primary/10'
  },
  // {
  //   type: 'tiktok',
  //   logo: '/images/icons/tik-tok.svg',
  //   name: 'Tiktok',
  //   class: 'bg-primary/10'
  // },
  // {
  //   type: 'copy',
  //   logo: '/images/all/copy.svg',
  //   name: 'Copier',
  //   class: 'bg-primary/10'
  // }
];

export const DEFAULT_STATE = {};
